import { Language, Subsidiary } from '@coolblue-development/constants';
import { Product as GenericProduct } from '@features/product/typings';

export type Property = {
  displayName: string;
  hasExplanation: boolean;
  propertyId: string;
  value: string;
};

export type PropertyGroup = {
  title: string;
  properties: Array<Property>;
};

export type ProductData = ({
  product: Product | null;
  hasAccessories: boolean;
} | null)[];

export enum AvailabilityState {
  AvailableSoon = 'AvailableSoon',
  OnStock = 'OnStock',
  TemporaryOutOfStock = 'TemporaryOutOfStock',
  OutOfStock = 'OutOfStock',
  Historic = 'Historic',
  PreOrder = 'PreOrder'
}

export type Product = {
  id: number;
  name: string;
  primaryImage: { id: string };
  productType: {
    productTypeId: number;
  };
  promoIcon?: GenericProduct['promoIcon'];
  listPrice: GenericProduct['listPrice'];
  salesPrice: GenericProduct['salesPrice'];
  urls: GenericProduct['urls'];
  energyLabel: GenericProduct['energyLabel'];
  coolbluesChoice: GenericProduct['coolbluesChoice'];
  reviewMetaData: GenericProduct['reviewMetaData'];
  promotionalContent: GenericProduct['promotionalContent'];
  properties: {
    propertyGroups: PropertyGroup[];
    summary: Property[];
  };
  availabilityState: AvailabilityState;
  subProducts?: { product: Product }[];
  shouldDisableAddToCart: boolean;
  isMandatoryPostalCodeSplitTestInVariation: boolean;
};

export type ComparisonPageRepositoryProps = {
  productIds: number[];
  subsidiary: Subsidiary;
  language: Language;
};

export type ComparisonProductResponseData = {
  [key: `product_${number}`]: Product | null;
};

export type ComparisonPage = {
  products: Array<Product | null>;
};

export interface ComparisonPageRepositoryInterface {
  getByProductIds(args: ComparisonPageRepositoryProps): Promise<ComparisonPage | null>;
}
